import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SplashScreen.css';

const SplashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login');
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="splash-screen">
      <img 
        src="/assets/Vert-LOGO.png" 
        alt="SOLlink Logo" 
        className="splash-logo"
      />
    </div>
  );
};

export default SplashScreen;













